import * as t from "io-ts";

export const BreakdanceNeededDataV = t.type({
  breakdanceVersion: t.string,
  homeUrl: t.string,
  adminUrl: t.string,
  wpContentUrl: t.string,
  linkChooserUrl: t.string,
  tinyMceUrl: t.string,
  breakdanceSettingsUrl: t.string,
  elementsPluginUrl: t.union([t.string, t.null]),
  elementsReusableDependenciesUrls: t.record(t.string, t.string),
  adminLoginUrl: t.string,
  browseModeAllowedUrls: t.array(t.string),
  isBuilderFirstTimeVisit: t.boolean
});

export type BreakdanceNeededData = t.TypeOf<typeof BreakdanceNeededDataV>;

export const BreakdanceDocumentSpecificNeededUrlsV = t.type({
  backToWordPressUrl: t.string,
  frontend: t.union([t.string, t.literal(false)]),
  iframeUrl: t.string,
  mediaChooserUrl: t.string
});

export type BreakdanceDocumentSpecificNeededUrls = t.TypeOf<
  typeof BreakdanceDocumentSpecificNeededUrlsV
>;
